const TransactionsPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Transactions</h1>
      <p>List of transactions</p>
    </div>
  );
};
export default TransactionsPage;
